<custom-table [config]="customTable" (emitterLazyLoad)="lazyloadRecords($event)" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>
<ng-template #tableRowexpansion let-data>
  <app-solicitud-historial-actividad [solicitudId]="data.id" [enableReasignar]="true"
                                     class="app-card mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>
